import { tenantConfig } from "@tenant-config";
import Image1 from "@vega-assets/images/login-banner-image-1.svg?react";
import Image2 from "@vega-assets/images/login-banner-image-2.svg?react";
import Image3 from "@vega-assets/images/login-banner-image-3.svg?react";
import { m } from "@vega-core/paraglide/messages";
import {
  type BannerItem,
  DEFAULT_LOGIN_BANNER_COLORS,
} from "@vega-modules/scenes/LPAuth/Login/components/Banner";

export const CoInvestmentsLPLoginBannerItems = (
  companyName: string,
): BannerItem[] => {
  const [browseColor, operationsColor, subscribeColor] =
    tenantConfig.branding.loginBannerColors ?? DEFAULT_LOGIN_BANNER_COLORS;

  return [
    {
      color: browseColor,
      icon: <Image1 />,
      title: m.coInvestments_lp_login_browseTitle(),
      description: m.coInvestments_lp_login_browseDescription({
        companyName,
      }),
    },
    {
      color: operationsColor,
      icon: <Image2 />,
      title: m.coInvestments_lp_login_operationsTitle(),
      description: m.coInvestments_lp_login_operationsDescription(),
    },
    {
      color: subscribeColor,
      icon: <Image3 />,
      title: m.coInvestments_lp_login_subscribeTitle(),
      description: m.coInvestments_lp_login_subscribeDescription(),
    },
  ];
};
